import React from 'react';

const OfficialBanner: React.FC = () => {
  return (
    <div className="official-banner" role="region" aria-label="Identificador del sitio">
      <div className="official-banner__inner">
        <span className="official-banner__mark" aria-hidden="true" />
        <p className="official-banner__text">
          Sitio oficial de <strong>Una Voz Diferente</strong>
          <span className="official-banner__sep" aria-hidden="true">
            ·
          </span>
          <span className="official-banner__meta">
            Organización juvenil peruana sin fines de lucro
          </span>
        </p>
      </div>
    </div>
  );
};

export default OfficialBanner;
